import { MyLink, MyLinkClickHandler } from 'components/MyLink'

export function SsaLink ({ children, onClick }: {children?: React.ReactNode, onClick?: MyLinkClickHandler}) {
  return (
    <MyLink href="https://www.ssa.gov/myaccount/" target='_blank' onClick={onClick}>{children}</MyLink>
  )
}
